import React, { useState } from "react";
import ProjectCard from "./ProjectCard";
import { Button, Col, Row } from "react-bootstrap";
import Projectdata from "../Data/Projectdata";

const Project = () => {
  const [projectType, setProjectType] = useState("official");
  const visibleProjects = Projectdata.filter((item) => item.type === projectType);

  return (
    <div>
      <div
        className="d-flex justify-content-center
    align-items-center tab-btn mb-5 "
      >
        <Button
          variant={` me-3  ${projectType === "official" ? " btn-main-btn" : ""}`}
          onClick={() => setProjectType("official")}
        >
          Official Projects
        </Button>
        <Button
          variant={`   ${projectType === "learning" ? " btn-main-btn" : ""}`}
          onClick={() => setProjectType("learning")}
        >
          Learning Projects
        </Button>
      </div>
      <Row>
        {visibleProjects.map((item) => (
          <Col md={4} key={item.title}>
            <ProjectCard data={item} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Project;
